import * as z from 'zod/mini';

export const PackageConfirmationRequestSchema = z.object({
  session_id: z.string(),
  type: z.enum(['booking', 'quotation']),
});

export const PackageConfirmationResponseSchema = z.object({
  message: z.string(),
});
